import type { ProjectionLog } from "../../../projections/projectionEngine.js";

type VoiceLogExtra = {
    video?: boolean;
    streaming?: boolean;
};

function readExtra(log: ProjectionLog): VoiceLogExtra {
    return log.extra && typeof log.extra === "object"
        ? log.extra as VoiceLogExtra
        : {};
}

export function getVoiceActionLabel(log: ProjectionLog): string {
    const extra = readExtra(log);

    switch (log.type) {
        case "voice_join":
            return "a rejoint";

        case "voice_leave":
            return "a quitté";

        case "voice_move":
            return "s'est déplacé";

        case "voice_state_update":
            return "a changé d'état";

        case "voice_state_video":
            return extra.video ? "a activé sa cam" : "a désactivé sa cam";

        case "voice_state_stream":
            return extra.streaming ? "a lancé un stream" : "a arrêté son stream";

        case "member_move":
            return "a été déplacé";

        case "member_disconnect":
            return "a été déconnecté";

        case "utils_voice_join":
            return "a été rejoint via commande";

        case "utils_voice_move":
            return "a été déplacé via commande";

        default:
            return log.type;
    }
}
